export default "__VITE_ASSET__C4dmqdz3__"